<div class="container">
  <div class="effects">
    <div class="scroller">
      @for (effect of effects; track effect) {
        <div class="card" pRipple (click)="selectEffect.emit(effect)">
          <p-tag
            class="tag"
            [icon]="effect.isLayer ? 'pi pi-clone' : 'pi pi-sparkles'"
            rounded
            [severity]="effect.isLayer ? 'info' : 'success'"
            >
          </p-tag>
          <div class="image-container">
            <div class="overlay"></div>
            <img class="image" [src]="effect.image">
          </div>
          <div class="label">
            {{ effect.label }}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="search">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input type="text" pInputText placeholder="Search" [formControl]="search"/>
    </p-iconField>
  </div>
</div>
